// Quiz & Guessing Game Data for Indian Schools & Events
// Curated for Science, Indian History, and General Knowledge

export const DEFAULT_QUIZ_QUESTIONS = [
  // --- SCIENCE & SPACE ---
  {
    id: 'sci_1',
    category: 'Science & Space',
    type: 'trivia',
    question: 'Which Indian space mission made history by soft-landing near the Moon\'s south pole in August 2023?',
    options: ['Mangalyaan', 'Chandrayaan-3', 'Aditya-L1', 'Gaganyaan'],
    correctIndex: 1,
    fact: 'India became the very first nation in human history to land near the lunar south pole!'
  },
  {
    id: 'sci_2',
    category: 'Science & Space',
    type: 'trivia',
    question: 'National Science Day in India is celebrated on February 28 to honor which Nobel Prize discovery?',
    options: ['The Raman Effect', 'Bose-Einstein Condensate', 'DNA Double Helix', 'Solar Cells'],
    correctIndex: 0,
    fact: 'Sir C.V. Raman discovered the Raman Effect in 1928, explaining why the sky and ocean scatter light.'
  },
  {
    id: 'sci_3',
    category: 'Science & Space',
    type: 'trivia',
    question: 'What green pigment in plant leaves absorbs sunlight to perform photosynthesis?',
    options: ['Carotene', 'Hemoglobin', 'Chlorophyll', 'Melanin'],
    correctIndex: 2,
    fact: 'Chlorophyll traps solar energy to convert water and carbon dioxide into glucose and oxygen.'
  },
  {
    id: 'sci_4',
    category: 'Science & Space',
    type: 'mystery',
    title: 'Mystery Inventor Challenge',
    question: 'Who Am I? (Science Edition)',
    clues: [
      'Clue 1: Born in Rameswaram, Tamil Nadu, I loved aeronautical engineering.',
      'Clue 2: Known as the "Missile Man of India" for developing Agni & Prithvi.',
      'Clue 3: I served as the beloved 11th President of India and wrote "Wings of Fire".'
    ],
    answer: 'Dr. A.P.J. Abdul Kalam',
    image: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=600&q=80',
    fact: 'Dr. Kalam always urged students: "Dream, dream, dream. Dreams transform into thoughts, and thoughts result in action."'
  },
  {
    id: 'sci_5',
    category: 'Science & Space',
    type: 'trivia',
    question: 'Which gas do plants release during the day that all humans and animals breathe to survive?',
    options: ['Carbon Dioxide', 'Nitrogen', 'Oxygen', 'Hydrogen'],
    correctIndex: 2,
    fact: 'Trees and plants are often called the green lungs of our planet Earth!'
  },

  // --- INDIAN HISTORY & HERITAGE ---
  {
    id: 'hist_1',
    category: 'History & Heritage',
    type: 'trivia',
    question: 'Who was the brave Queen of Jhansi who fought valiantly during the Indian Rebellion of 1857?',
    options: ['Rani Padmavati', 'Rani Lakshmibai', 'Razia Sultana', 'Kittur Chennamma'],
    correctIndex: 1,
    fact: 'Rani Lakshmibai fought fearlessly with her adopted son tied to her back, inspiring the cry: "Khoob ladi mardani woh toh Jhansi wali rani thi!"'
  },
  {
    id: 'hist_2',
    category: 'History & Heritage',
    type: 'trivia',
    question: 'The Ashoka Chakra in our Indian National Tricolor flag contains how many spokes?',
    options: ['12 Spokes', '18 Spokes', '24 Spokes', '32 Spokes'],
    correctIndex: 2,
    fact: 'The 24 spokes represent the 24 eternal virtues and 24 hours of continuous progress in a day.'
  },
  {
    id: 'hist_3',
    category: 'History & Heritage',
    type: 'mystery',
    title: 'Mystery Historical Hero',
    question: 'Who Am I? (History Edition)',
    clues: [
      'Clue 1: I established the Maratha Empire and carved out Swarajya in the 17th century.',
      'Clue 2: Known for revolutionary guerrilla warfare tactics called Ganimi Kawa.',
      'Clue 3: Crowned Chhatrapati at the majestic Raigad Fort in 1674.'
    ],
    answer: 'Chhatrapati Shivaji Maharaj',
    image: 'https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?auto=format&fit=crop&w=600&q=80',
    fact: 'Chhatrapati Shivaji Maharaj built a formidable navy and fortified over 300 hill forts across the Sahyadri mountains.'
  },
  {
    id: 'hist_4',
    category: 'History & Heritage',
    type: 'trivia',
    question: 'Who wrote the Indian National Anthem "Jana Gana Mana"?',
    options: ['Bankim Chandra Chattopadhyay', 'Rabindranath Tagore', 'Sarojini Naidu', 'Subhash Chandra Bose'],
    correctIndex: 1,
    fact: 'Gurudev Rabindranath Tagore was Asia\'s first Nobel laureate in Literature (1913).'
  },
  {
    id: 'hist_5',
    category: 'History & Heritage',
    type: 'trivia',
    question: 'The historic Red Fort in Old Delhi was constructed during the reign of which Mughal Emperor?',
    options: ['Akbar', 'Shah Jahan', 'Babur', 'Aurangzeb'],
    correctIndex: 1,
    fact: 'Every year on 15th August, the Prime Minister of India unfurls the National Flag from the ramparts of the Red Fort.'
  },

  // --- GENERAL KNOWLEDGE & NATURE ---
  {
    id: 'gk_1',
    category: 'General Knowledge',
    type: 'trivia',
    question: 'What is the National Aquatic Animal of India, found in the sacred river Ganga?',
    options: ['Ganges River Dolphin', 'Olive Ridley Turtle', 'Gharial Crocodile', 'Golden Mahseer'],
    correctIndex: 0,
    fact: 'The Ganges River Dolphin is virtually blind and hunts using sophisticated echolocation clicks!'
  },
  {
    id: 'gk_2',
    category: 'General Knowledge',
    type: 'trivia',
    question: 'Which is the highest mountain peak situated entirely within India?',
    options: ['Mount Everest', 'Kanchenjunga', 'Nanda Devi', 'K2'],
    correctIndex: 2,
    fact: 'Nanda Devi stands at 7,816 meters (25,643 ft) in Uttarakhand, while Kanchenjunga lies on the Sikkim-Nepal border.'
  },
  {
    id: 'gk_3',
    category: 'General Knowledge',
    type: 'mystery',
    title: 'Mystery Wonder of Nature',
    question: 'What Am I? (Nature Edition)',
    clues: [
      'Clue 1: I am the National Bird of India, declared in 1963.',
      'Clue 2: My male species exhibits a spectacular iridescent train of eye-spotted feathers.',
      'Clue 3: My majestic dance heralds the arrival of the monsoon rain clouds.'
    ],
    answer: 'The Indian Peafowl (Peacock)',
    image: 'https://images.unsplash.com/photo-1544717305-2782549b5136?auto=format&fit=crop&w=600&q=80',
    fact: 'The peacock features prominently in Indian folklore, temple sculptures, and the sacred iconography of Lord Murugan.'
  },
  {
    id: 'gk_4',
    category: 'General Knowledge',
    type: 'trivia',
    question: 'Who designed the official Indian Rupee currency symbol (₹) adopted in 2010?',
    options: ['D. Udaya Kumar', 'Raghuram Rajan', 'Nandan Nilekani', 'R.K. Laxman'],
    correctIndex: 0,
    fact: 'Dr. D. Udaya Kumar blended the Devanagari "र" (ra) and Roman capital "R" with dual horizontal stripes representing our tricolor.'
  },
  {
    id: 'gk_5',
    category: 'General Knowledge',
    type: 'trivia',
    question: 'Which planet in our solar system has the most prominent and beautiful rings?',
    options: ['Jupiter', 'Saturn', 'Mars', 'Neptune'],
    correctIndex: 1,
    fact: 'Saturn\'s dazzling rings are composed of billions of pieces of ice, rock, and cosmic dust.'
  }
];

export const SCHOOL_HOUSE_TEAMS = [
  { id: 'red', name: 'Ruby Lions', house: 'Red House', color: 'from-rose-500 to-red-600', badge: '🦁' },
  { id: 'blue', name: 'Sapphire Eagles', house: 'Blue House', color: 'from-blue-500 to-indigo-600', badge: '🦅' },
  { id: 'green', name: 'Emerald Tigers', house: 'Green House', color: 'from-emerald-500 to-teal-600', badge: '🐯' },
  { id: 'yellow', name: 'Golden Falcons', house: 'Yellow House', color: 'from-amber-400 to-yellow-500', badge: '⚡' }
];

export const DEFAULT_SCHOOL_AWARDS = [
  { id: 'badge_science', emoji: '🔬', title: 'Science Whiz Award', item: 'Enamel Science Badge + Certificate' },
  { id: 'badge_history', emoji: '📜', title: 'History Maestro Award', item: 'Heritage Scholar Badge + Certificate' },
  { id: 'badge_gk', emoji: '💡', title: 'Mastermind GK Champion', item: 'Golden Trophy Badge + Certificate' },
  { id: 'cap_champ', emoji: '🧢', title: 'School Champion Cap', item: 'Custom Embroidered Event Cap' },
  { id: 'hamper', emoji: '🎁', title: 'Super Student STEM Hamper', item: 'Mega Stationery & Activity Kit' }
];

export const SCHOOL_REWARD_BADGES = DEFAULT_SCHOOL_AWARDS;

const STORAGE_KEY_QUIZ_QUESTIONS = 'gamifycenter_quiz_questions';
const STORAGE_KEY_HOUSE_SCORES = 'gamifycenter_house_scores';
const STORAGE_KEY_BALLOON_ENTRIES = 'gamifycenter_balloon_entries';
const STORAGE_KEY_SCHOOL_AWARDS = 'gamifycenter_school_awards';

export const getSchoolAwards = () => {
  if (typeof window === 'undefined') return DEFAULT_SCHOOL_AWARDS;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_SCHOOL_AWARDS);
    if (!raw) return DEFAULT_SCHOOL_AWARDS;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : DEFAULT_SCHOOL_AWARDS;
  } catch (e) {
    return DEFAULT_SCHOOL_AWARDS;
  }
};

export const saveSchoolAwards = (awards) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_SCHOOL_AWARDS, JSON.stringify(awards));
    window.dispatchEvent(new Event('schoolAwardsUpdated'));
  } catch (e) {
    console.warn('Failed to save school awards', e);
  }
};

export const getQuizQuestions = () => {
  if (typeof window === 'undefined') return DEFAULT_QUIZ_QUESTIONS;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_QUIZ_QUESTIONS);
    if (!raw) return DEFAULT_QUIZ_QUESTIONS;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : DEFAULT_QUIZ_QUESTIONS;
  } catch (e) {
    return DEFAULT_QUIZ_QUESTIONS;
  }
};

export const saveQuizQuestions = (questions) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_QUIZ_QUESTIONS, JSON.stringify(questions));
    window.dispatchEvent(new Event('quizQuestionsUpdated'));
  } catch (e) {
    console.warn('Failed to save quiz questions', e);
  }
};

export const getHouseScores = () => {
  const defaultScores = { red: 0, blue: 0, green: 0, yellow: 0 };
  if (typeof window === 'undefined') return defaultScores;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_HOUSE_SCORES);
    if (!raw) return defaultScores;
    const parsed = JSON.parse(raw);
    return (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) 
      ? { ...defaultScores, ...parsed } 
      : defaultScores;
  } catch (e) {
    return defaultScores;
  }
};

export const saveHouseScores = (scores) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_HOUSE_SCORES, JSON.stringify(scores));
    window.dispatchEvent(new Event('houseScoresUpdated'));
  } catch (e) {
    console.warn('Failed to save house scores', e);
  }
};

// --- Physical Sports & Championship Barometer Data ---
export const DEFAULT_PHYSICAL_SPORTS = [
  // 🎈 Indoor Fun Games for Children Under 7 Years Old
  { 
    id: 'sport_balloon_keepup', 
    name: 'Balloon Keep-Up Challenge', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🎈',
    recommendedAge: 'Ages 3-6 / Under 7',
    rules: [
      'Teams must keep 3 colorful balloons in the air without letting them touch the floor.',
      'Only soft hand taps, head bobs, or gentle kicks are allowed.',
      'If a balloon touches the floor, that team loses a balloon.',
      'Team with balloons remaining in the air after 60 seconds wins!'
    ],
    objective: 'Keep all team balloons floating in the air for 60 seconds'
  },
  { 
    id: 'sport_freeze_dance', 
    name: 'Musical Statues & Freeze Dance', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🎶',
    recommendedAge: 'Ages 3-6 / Under 7',
    rules: [
      'Children dance and groove to high-energy music in their house zones.',
      'When the music suddenly pauses, everyone must freeze instantly like a statue!',
      'Anyone who giggles, wobbles, or moves is eliminated for that round.',
      'Last 3 dancers standing score podium points for their house!'
    ],
    objective: 'Freeze completely still the moment the music stops'
  },
  { 
    id: 'sport_duck_goose', 
    name: 'Duck Duck Goose Circle Dash', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🦆',
    recommendedAge: 'Ages 4-7 / Under 7',
    rules: [
      'Children sit in a friendly circle.',
      'The picker walks around tapping heads saying "Duck... Duck... Goose!".',
      'The chosen Goose jumps up and chases the picker around the circle.',
      'Fastest runner back to the empty spot scores points for their house team!'
    ],
    objective: 'Tag the picker or race back to the open spot in the circle'
  },
  { 
    id: 'sport_frog_lilypad', 
    name: 'Frog Leap & Lily Pad Hop', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🐸',
    recommendedAge: 'Ages 3-6 / Under 7',
    rules: [
      'Floor is marked with soft green lily-pad mats or hoops.',
      'Little frogs must leap with two feet from pad to pad to cross the pond.',
      'Stepping off a lily pad sends you back one leap.',
      'First frog to reach the golden lotus flower wins the race!'
    ],
    objective: 'Hop across soft lily pads without touching the floor'
  },
  { 
    id: 'sport_soft_tower', 
    name: 'Giant Soft Block Tower Build', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🧩',
    recommendedAge: 'Ages 4-7 / Under 7',
    rules: [
      'Each house gets 20 lightweight foam or cardboard building blocks.',
      'Teams have 60 seconds to work together and stack the tallest tower.',
      'Towers must stand unsupported for 5 seconds after time is called.',
      'Tallest standing tower measured with a referee stick wins!'
    ],
    objective: 'Cooperate to build the tallest stable block tower in 60 seconds'
  },
  { 
    id: 'sport_bear_crawl', 
    name: 'Bear Crawl & Tunnel Explorer', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🐻',
    recommendedAge: 'Ages 3-6 / Under 7',
    rules: [
      'Children crawl on hands and feet like baby bears through soft pop-up tunnels.',
      'At the far end, grab their House mascot plushie or flag.',
      'Crawl safely back and high-five the next teammate in line.',
      'Fastest and safest relay team takes 1st place!'
    ],
    objective: 'Crawl through the soft tunnel to rescue the house mascot'
  },
  { 
    id: 'sport_soft_egg_spoon', 
    name: 'Soft Ball & Spoon Balance Walk', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🥄',
    recommendedAge: 'Ages 3-6 / Under 7',
    rules: [
      'Children carry a lightweight plastic ball balanced on a colorful spoon.',
      'Must walk briskly (no running) around the cone and back.',
      'If the ball drops, child must stop, place it back on, and continue.',
      'No using thumbs or fingers to hold the ball down!'
    ],
    objective: 'Balance the soft ball across the finish line with one hand'
  },
  { 
    id: 'sport_bean_bag_toss', 
    name: 'Bean Bag Bucket Target Toss', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🎯',
    recommendedAge: 'Ages 3-7 / Under 7',
    rules: [
      'Children stand behind the throw line (1.5 - 2 meters away).',
      'Each child gets 4 soft colored bean bags to toss into House buckets.',
      'Bucket 1 = 10 pts, Bucket 2 = 20 pts, Center Gold Bucket = 30 pts.',
      'Total points earned contribute directly to the House Barometer!'
    ],
    objective: 'Toss soft bean bags into scoring buckets'
  },
  { 
    id: 'sport_color_corner', 
    name: 'Color Corner Dash', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🏃‍♂️',
    recommendedAge: 'Ages 3-6 / Under 7',
    rules: [
      'Four corners of the room are marked: Red, Blue, Green, Yellow.',
      'Children dance in the center to upbeat music.',
      'When the referee blows the whistle and calls a color, children dash to that corner!',
      'First full house team to assemble safely in their zone scores 25 points!'
    ],
    objective: 'Listen carefully and dash safely to the announced color corner'
  },
  { 
    id: 'sport_animal_relay', 
    name: 'Animal Kingdom Walk Relay', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🦁',
    recommendedAge: 'Ages 4-7 / Under 7',
    rules: [
      'Leg 1: Waddle like cute penguins to Cone 1.',
      'Leg 2: Hop like bouncy bunnies to Cone 2.',
      'Leg 3: Roar like majestic lions while jogging back to tag teammate.',
      'Encourages full-body coordination, animal sounds, and lots of giggles!'
    ],
    objective: 'Imitate animals and complete the relay safely'
  },
  { 
    id: 'sport_rainbow_ring', 
    name: 'Rainbow Ring Toss Challenge', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🌈',
    recommendedAge: 'Ages 3-6 / Under 7',
    rules: [
      'Toss soft foam rings over matching colored safety cones.',
      'Each ringer on your house cone earns points.',
      'Team to hook 5 rings first wins the championship!'
    ],
    objective: 'Toss rings over target cones'
  },
  { 
    id: 'sport_treasure_clean', 
    name: 'Treasure Hunt Clean-Up Dash', 
    category: 'Indoor Fun (<7 Years)', 
    icon: '🧺',
    recommendedAge: 'Ages 3-6 / Under 7',
    rules: [
      '50 soft plastic ball-pit balls are scattered across the play floor.',
      'On "GO!", children rush to collect balls matching their house color.',
      'Place balls into your team\'s house basket one or two at a time.',
      'Team with the most balls gathered in 60 seconds wins!'
    ],
    objective: 'Collect all your team\'s colored treasure balls'
  },

  // 🏃 Track & Athletics
  { 
    id: 'sport_100m', 
    name: '100m Dash Sprint', 
    category: 'Track & Athletics', 
    icon: '🏃',
    recommendedAge: 'Grades 3-12',
    rules: [
      'Runners must stay in their designated lanes throughout the race.',
      'False starts result in a restart; second false start is a warning.',
      'Winner is determined by whose torso crosses the finish line first.'
    ],
    objective: 'Sprint 100 meters in the fastest recorded time'
  },
  { 
    id: 'sport_200m', 
    name: '200m Sprint Race', 
    category: 'Track & Athletics', 
    icon: '⚡',
    recommendedAge: 'Grades 5-12',
    rules: [
      'Staggered start positions around the track curve.',
      'Maintain your lane through the curve and final straightaway.',
      'Finish line camera / referee judging for tight finishes.'
    ],
    objective: 'Sprint 200 meters around the track curve'
  },
  { 
    id: 'sport_relay', 
    name: '4x100m Inter-House Relay', 
    category: 'Track & Athletics', 
    icon: '🏃‍♂️',
    recommendedAge: 'Grades 4-12',
    rules: [
      '4 runners per house team with official baton exchange.',
      'Baton pass must occur inside the 20-meter changeover box.',
      'Dropping the baton requires the dropping runner to pick it up.',
      'Anchor leg runner crossing the line wins for the house!'
    ],
    objective: 'Complete 400m team relay with flawless baton handoffs'
  },
  { 
    id: 'sport_hurdles', 
    name: 'Hurdle Race', 
    category: 'Track & Athletics', 
    icon: '🚧',
    recommendedAge: 'Grades 6-12',
    rules: [
      'Runners must clear all hurdles in their lane.',
      'Knocking down a hurdle accidentally does not disqualify, but slowing down affects position.',
      'Intentional knocking or stepping around hurdles is disqualified.'
    ],
    objective: 'Sprint and jump cleanly over hurdles'
  },
  { 
    id: 'sport_long_jump', 
    name: 'Long Jump Contest', 
    category: 'Track & Athletics', 
    icon: '👟',
    recommendedAge: 'Grades 4-12',
    rules: [
      'Each athlete gets 3 official attempts.',
      'Takeoff foot must not cross the takeoff board foul line.',
      'Distance measured from takeoff line to the nearest point of touch in the sand pit.'
    ],
    objective: 'Achieve the longest horizontal jump distance'
  },

  // 🤼 Field & Team Games
  { 
    id: 'sport_tug_of_war', 
    name: 'Tug of War Championship', 
    category: 'Field & Team Games', 
    icon: '🤼',
    recommendedAge: 'All Grades & Divisions',
    rules: [
      'Teams of 8 athletes with equal weight or age division.',
      'Center ribbon aligned with field marker on referee whistle.',
      'Team that pulls the center ribbon 2 meters across their win marker wins.',
      'Best 2 out of 3 pulls decides the champion.'
    ],
    objective: 'Pull the opposing house across the centerline marker'
  },
  { 
    id: 'sport_penalty', 
    name: 'Football Penalty Shootout', 
    category: 'Field & Team Games', 
    icon: '⚽',
    recommendedAge: 'Grades 3-12',
    rules: [
      '5 penalty kicks per house team taken from the penalty spot.',
      'Shooter must kick forward with a continuous motion.',
      'Goalkeeper must stay on goal line until ball is kicked.',
      'Sudden death rounds if scores are tied after 5 kicks.'
    ],
    objective: 'Score the highest number of penalty goals'
  },
  { 
    id: 'sport_basketball', 
    name: 'Basketball Free Throws', 
    category: 'Field & Team Games', 
    icon: '🏀',
    recommendedAge: 'Grades 4-12',
    rules: [
      'Shooters take shots from the free throw line.',
      '10 shots per team; each basket earns 2 points.',
      'Shooter cannot step over the line until the ball touches the rim.'
    ],
    objective: 'Sink the most free-throw baskets'
  },
  { 
    id: 'sport_dodgeball', 
    name: 'Dodgeball Clash', 
    category: 'Field & Team Games', 
    icon: '🎯',
    recommendedAge: 'Grades 4-12',
    rules: [
      'Soft foam balls only; center rush on opening whistle.',
      'Direct hit eliminates player unless caught in air (which brings a teammate back!).',
      'Team with last surviving player on the court wins the round.'
    ],
    objective: 'Eliminate opposing players by tagging them with soft balls'
  },

  // 🥔 Fun & Carnival Races
  { 
    id: 'sport_sack', 
    name: 'Sack Race Obstacle', 
    category: 'Fun & Carnival Races', 
    icon: '🥔',
    recommendedAge: 'Grades 1-8',
    rules: [
      'Both feet inside the burlap or canvas sack at all times.',
      'Hold the top of the sack at waist height while hopping.',
      'If you fall, get back up inside the sack before continuing.',
      'First hopper across the finish line wins!'
    ],
    objective: 'Hop inside the sack across the course to the finish line'
  },
  { 
    id: 'sport_three_legged', 
    name: 'Three-Legged Partner Race', 
    category: 'Fun & Carnival Races', 
    icon: '🤝',
    recommendedAge: 'Grades 2-8',
    rules: [
      'Two partners stand side by side; inside legs tied securely with soft band.',
      'Partners must coordinate walking/running in rhythm ("Inside, Outside!").',
      'If band slips, stop and refasten before continuing.',
      'Cross the finish line together upright.'
    ],
    objective: 'Teamwork and synchrony to race with legs tied together'
  },
  { 
    id: 'sport_lemon_spoon', 
    name: 'Lemon & Spoon Balance', 
    category: 'Fun & Carnival Races', 
    icon: '🍋',
    recommendedAge: 'Grades 1-6',
    rules: [
      'Spoon handle held firmly in teeth or single hand (depending on age division).',
      'Lemon balanced on spoon bowl without touching hands.',
      'If lemon falls, return to drop point, replace lemon, and proceed.',
      'First to cross the line with lemon intact wins.'
    ],
    objective: 'Maintain perfect balance walking across the finish line'
  },
  { 
    id: 'sport_obstacle', 
    name: 'Junior Obstacle Course', 
    category: 'Fun & Carnival Races', 
    icon: '🧗',
    recommendedAge: 'Grades 1-8',
    rules: [
      'Station 1: Hula hoop zigzag hop.',
      'Station 2: Low crawl under agility mesh.',
      'Station 3: Balance beam walk.',
      'Station 4: Cone sprint to the finish line bell!'
    ],
    objective: 'Complete all 4 agility obstacle stations in fastest time'
  },

  // 🎖️ Drill & Spirit
  { 
    id: 'sport_march_past', 
    name: 'March Past & Drill Display', 
    category: 'Drill & Team Spirit', 
    icon: '🎖️',
    recommendedAge: 'All Houses / School Wide',
    rules: [
      'Judged on alignment, synchronized cadence, uniform neatness, and flag salute.',
      'House captains lead with official salute to the Chief Guest podium.',
      'Scored by 3 independent judges on a 100-point scale.'
    ],
    objective: 'Display supreme discipline, marching unison, and house pride'
  },
  { 
    id: 'sport_cheer', 
    name: 'House Cheer & War Cry', 
    category: 'Drill & Team Spirit', 
    icon: '📣',
    recommendedAge: 'All Houses',
    rules: [
      '2-minute synchronized cheer or house anthem.',
      'Judged on loudness, rhythm, creative choreography, and positive sporting spirit.',
      'Zero unsportsmanlike taunts allowed.'
    ],
    objective: 'Rally team enthusiasm and stadium crowd support'
  },
  { 
    id: 'sport_sportsmanship', 
    name: 'Best Sportsmanship Award', 
    category: 'Drill & Team Spirit', 
    icon: '🌟',
    recommendedAge: 'All Houses',
    rules: [
      'Awarded to the house demonstrating the greatest respect, kindness, and fair play.',
      'Encouraging rivals, helping fallen runners, and respecting referee calls.',
      'Carries special prestigious bonus points on the Barometer!'
    ],
    objective: 'Demonstrate exemplary integrity, kindness, and fair play'
  }
];

const STORAGE_KEY_SPORTS_EVENTS = 'gamifycenter_sports_events';
const STORAGE_KEY_HOUSE_MEDALS = 'gamifycenter_house_medals';
const STORAGE_KEY_CUSTOM_HOUSES = 'gamifycenter_custom_houses';
const STORAGE_KEY_ACTIVE_SPORT_EVENT = 'gamifycenter_active_sport_event';
const STORAGE_KEY_ORGANIZER_NAME = 'gamifycenter_organizer_name';
const STORAGE_KEY_CUSTOM_SPORTS_LIBRARY = 'gamifycenter_custom_sports_library';

// Helper: Custom Sports Library
export const getCustomSportsLibrary = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY_CUSTOM_SPORTS_LIBRARY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const saveCustomSportsLibrary = (sports) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_CUSTOM_SPORTS_LIBRARY, JSON.stringify(Array.isArray(sports) ? sports : []));
    window.dispatchEvent(new Event('sportsLibraryUpdated'));
  } catch (e) {
    console.warn('Failed to save custom sports library', e);
  }
};

export const getAllSports = () => {
  const custom = getCustomSportsLibrary();
  return [...DEFAULT_PHYSICAL_SPORTS, ...custom];
};

// Helper: Active Sport Broadcast (Current Match on Projector)
export const getActiveSportEvent = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_ACTIVE_SPORT_EVENT);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return (parsed && typeof parsed === 'object') ? parsed : null;
  } catch (e) {
    return null;
  }
};

export const saveActiveSportEvent = (event) => {
  if (typeof window === 'undefined') return;
  try {
    if (!event) {
      localStorage.removeItem(STORAGE_KEY_ACTIVE_SPORT_EVENT);
    } else {
      localStorage.setItem(STORAGE_KEY_ACTIVE_SPORT_EVENT, JSON.stringify(event));
    }
    window.dispatchEvent(new Event('activeSportEventUpdated'));
  } catch (e) {
    console.warn('Failed to save active sport event', e);
  }
};

// Helper: School / Event Organizer Name
export const getOrganizerName = () => {
  const defaultName = 'Delhi Public School Annual Sports Championship';
  if (typeof window === 'undefined') return defaultName;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_ORGANIZER_NAME);
    return (raw && typeof raw === 'string' && raw.trim().length > 0) ? raw.trim() : defaultName;
  } catch (e) {
    return defaultName;
  }
};

export const saveOrganizerName = (name) => {
  if (typeof window === 'undefined') return;
  try {
    const sanitized = (name && typeof name === 'string' && name.trim()) ? name.trim() : 'Delhi Public School Annual Sports Championship';
    localStorage.setItem(STORAGE_KEY_ORGANIZER_NAME, sanitized);
    window.dispatchEvent(new Event('organizerNameUpdated'));
  } catch (e) {
    console.warn('Failed to save organizer name', e);
  }
};

export const getSportsEvents = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY_SPORTS_EVENTS);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const saveSportsEvents = (events) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_SPORTS_EVENTS, JSON.stringify(Array.isArray(events) ? events : []));
    window.dispatchEvent(new Event('sportsEventsUpdated'));
  } catch (e) {
    console.warn('Failed to save sports events', e);
  }
};

// --- Inter-House Champions & Barometer Winning Threshold Storage ---
const STORAGE_KEY_INTER_HOUSE_CHAMPIONS = 'gamifycenter_inter_house_champions';
const STORAGE_KEY_POINTS_GAIN_LIMIT = 'gamifycenter_barometer_points_limit';

export const getBarometerPointsLimit = () => {
  if (typeof window === 'undefined') return 100;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_POINTS_GAIN_LIMIT);
    if (!raw) return 100;
    const val = parseInt(raw, 10);
    return isNaN(val) || val <= 0 ? 100 : val;
  } catch (e) {
    return 100;
  }
};

export const saveBarometerPointsLimit = (limit) => {
  if (typeof window === 'undefined') return;
  try {
    const val = parseInt(limit, 10);
    const validLimit = isNaN(val) || val <= 0 ? 100 : val;
    localStorage.setItem(STORAGE_KEY_POINTS_GAIN_LIMIT, validLimit.toString());
    window.dispatchEvent(new Event('barometerPointsLimitUpdated'));
  } catch (e) {
    console.warn('Failed to save barometer points limit', e);
  }
};

export const getInterHouseChampions = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY_INTER_HOUSE_CHAMPIONS);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const saveInterHouseChampions = (champions) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_INTER_HOUSE_CHAMPIONS, JSON.stringify(Array.isArray(champions) ? champions : []));
    window.dispatchEvent(new Event('interHouseChampionsUpdated'));
  } catch (e) {
    console.warn('Failed to save inter house champions', e);
  }
};

export const announceInterHouseChampion = ({
  houseId,
  houseName,
  badge,
  points,
  awardType = '🏆 Overall Annual Inter-House Championship Trophy',
  eventSource = 'Inter-House Championship',
  prizeDistributionInfo = 'Trophy, Gold Medals & Certificates presented to winning House',
  announcedBy = 'Chief Sports Referee / Quiz Master'
}) => {
  const current = getInterHouseChampions();
  const championRecord = {
    id: `champ_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`,
    houseId,
    houseName,
    badge,
    points,
    awardType,
    eventSource,
    prizeDistributionInfo,
    announcedBy,
    timestamp: new Date().toISOString()
  };
  
  const updatedChampions = [championRecord, ...current];
  saveInterHouseChampions(updatedChampions);

  // Also log into Sports Day Log & Match History for information regarding the distribution of prizes!
  const sportsEvents = getSportsEvents();
  const matchEvent = {
    id: `event_champ_${Date.now()}_${Math.random().toString(36).substr(2, 6)}`,
    sport: `🏆 Champion Award: ${awardType}`,
    category: eventSource,
    houseId,
    houseName,
    athlete: `${houseName} House Champions`,
    place: '1st',
    pointsWon: points,
    timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    notes: `Official Winner Announcement: ${awardType}. Prize Distribution Info: ${prizeDistributionInfo}`
  };
  saveSportsEvents([matchEvent, ...sportsEvents]);

  return championRecord;
};

export const deleteInterHouseChampion = (id) => {
  const current = getInterHouseChampions();
  const updated = current.filter(c => c.id !== id);
  saveInterHouseChampions(updated);
};

export const getHouseMedals = () => {
  const defaultMedals = {
    red: { gold: 0, silver: 0, bronze: 0 },
    blue: { gold: 0, silver: 0, bronze: 0 },
    green: { gold: 0, silver: 0, bronze: 0 },
    yellow: { gold: 0, silver: 0, bronze: 0 }
  };
  if (typeof window === 'undefined') return defaultMedals;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_HOUSE_MEDALS);
    if (!raw) return defaultMedals;
    const parsed = JSON.parse(raw);
    return (parsed && typeof parsed === 'object') ? { ...defaultMedals, ...parsed } : defaultMedals;
  } catch (e) {
    return defaultMedals;
  }
};

export const saveHouseMedals = (medals) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_HOUSE_MEDALS, JSON.stringify(medals));
    window.dispatchEvent(new Event('houseMedalsUpdated'));
  } catch (e) {
    console.warn('Failed to save house medals', e);
  }
};

export const getCustomHouses = () => {
  if (typeof window === 'undefined') return SCHOOL_HOUSE_TEAMS;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_CUSTOM_HOUSES);
    if (!raw) return SCHOOL_HOUSE_TEAMS;
    const parsed = JSON.parse(raw);
    return (Array.isArray(parsed) && parsed.length > 0) ? parsed : SCHOOL_HOUSE_TEAMS;
  } catch (e) {
    return SCHOOL_HOUSE_TEAMS;
  }
};

export const saveCustomHouses = (houses) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_CUSTOM_HOUSES, JSON.stringify(Array.isArray(houses) ? houses : SCHOOL_HOUSE_TEAMS));
    window.dispatchEvent(new Event('customHousesUpdated'));
  } catch (e) {
    console.warn('Failed to save custom houses', e);
  }
};

// --- Live Emoji & Visual Riddle Dataset ---
export const DEFAULT_EMOJI_RIDDLES = [
  {
    id: 'riddle_1',
    category: "Indian Heritage & Wonders",
    emojis: ["🕌", "🤍", "🏛️", "👑"],
    emojiClues: ["Historic Monument", "Pure White Marble", "Mughal Architecture", "Emperor's Love"],
    image: "https://images.unsplash.com/photo-1564507592333-c60657eea523?auto=format&fit=crop&w=600&q=80",
    options: [
      { text: "Taj Mahal, Agra", emoji: "🕌" },
      { text: "Qutub Minar, Delhi", emoji: "🗼" },
      { text: "Hawa Mahal, Jaipur", emoji: "🏛️" },
      { text: "Gateway of India, Mumbai", emoji: "⚓" }
    ],
    correctIndex: 0,
    answer: "Taj Mahal, Agra",
    hint: "One of the Seven Wonders of the World, built in white marble on the banks of River Yamuna.",
    funFact: "Commissioned in 1631 by Mughal Emperor Shah Jahan in memory of his beloved empress Mumtaz Mahal."
  },
  {
    id: 'riddle_2',
    category: "Space & Science",
    emojis: ["🚀", "🌕", "🇮🇳", "🛰️"],
    emojiClues: ["Rocket Launch", "Moon Landing", "ISRO India", "Orbiter & Rover"],
    image: "https://images.unsplash.com/photo-1614728894747-a83421e2b9c9?auto=format&fit=crop&w=600&q=80",
    options: [
      { text: "Mangalyaan Mars Mission", emoji: "🔴" },
      { text: "Chandrayaan-3 Mission", emoji: "🌕" },
      { text: "Aditya-L1 Solar Mission", emoji: "☀️" },
      { text: "Gaganyaan Crew Mission", emoji: "👨‍🚀" }
    ],
    correctIndex: 1,
    answer: "Chandrayaan-3 Mission",
    hint: "India made history as the very first nation on Earth to soft-land near the Moon's South Pole.",
    funFact: "Soft-landed on August 23, 2023, now celebrated nationwide as National Space Day in India!"
  },
  {
    id: 'riddle_3',
    category: "Animals & Wildlife Heritage",
    emojis: ["🐅", "🇮🇳", "🐾", "🌿"],
    emojiClues: ["Royal Predator", "National Pride", "Silent Paws", "Jungle Habitat"],
    image: "https://images.unsplash.com/photo-1561731216-c3a4d99437d5?auto=format&fit=crop&w=600&q=80",
    options: [
      { text: "Asiatic Lion (Gir)", emoji: "🦁" },
      { text: "Indian Leopard", emoji: "🐆" },
      { text: "Royal Bengal Tiger", emoji: "🐅" },
      { text: "Himalayan Snow Leopard", emoji: "❄️" }
    ],
    correctIndex: 2,
    answer: "Royal Bengal Tiger",
    hint: "India's magnificent National Animal known for its royal gait and orange-black stripes.",
    funFact: "Under Project Tiger, India now protects over 75% of the world's wild tiger population."
  },
  {
    id: 'riddle_4',
    category: "Great Scientists & Physics",
    emojis: ["🍎", "🌳", "⬇️", "🧠"],
    emojiClues: ["Falling Apple", "Tree Orchard", "Downward Gravity", "Genius Mind"],
    image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=600&q=80",
    options: [
      { text: "Theory of Relativity", emoji: "⚡" },
      { text: "Law of Gravity (Isaac Newton)", emoji: "🍎" },
      { text: "Discovery of Electricity", emoji: "💡" },
      { text: "Radio Waves (J.C. Bose)", emoji: "📡" }
    ],
    correctIndex: 1,
    answer: "Law of Gravity (Isaac Newton)",
    hint: "Discovered in the 17th century when an apple fell from a tree in England.",
    funFact: "Sir Isaac Newton's three laws of motion govern how planets orbit and how sports balls move!"
  },
  {
    id: 'riddle_5',
    category: "Indian Sports Legends",
    emojis: ["🏏", "🇮🇳", "🏆", "1️⃣0️⃣0️⃣"],
    emojiClues: ["Cricket Willow", "Team India", "World Cup Trophy", "100 Centuries"],
    image: "https://images.unsplash.com/photo-1531415074868-036b107e775a?auto=format&fit=crop&w=600&q=80",
    options: [
      { text: "Virat Kohli", emoji: "👑" },
      { text: "M.S. Dhoni (Captain Cool)", emoji: "🧤" },
      { text: "Sachin Tendulkar (Master Blaster)", emoji: "🏏" },
      { text: "Kapil Dev (1983 Champion)", emoji: "🏆" }
    ],
    correctIndex: 2,
    answer: "Sachin Tendulkar (Master Blaster)",
    hint: "The legendary cricketer who scored 100 international centuries and inspired billions.",
    funFact: "He was awarded the Bharat Ratna, India's highest civilian honor, in 2014."
  },
  {
    id: 'riddle_6',
    category: "National Symbols & Nature",
    emojis: ["🦚", "🌧️", "💃", "✨"],
    emojiClues: ["Peacock Bird", "Monsoon Clouds", "Rain Dance", "Iridescent Colors"],
    image: "https://images.unsplash.com/photo-1544717305-2782549b5136?auto=format&fit=crop&w=600&q=80",
    options: [
      { text: "Indian Peacock (National Bird)", emoji: "🦚" },
      { text: "Great Indian Bustard", emoji: "🦅" },
      { text: "Himalayan Monal", emoji: "🏔️" },
      { text: "Kingfisher Bird", emoji: "🐟" }
    ],
    correctIndex: 0,
    answer: "Indian Peacock (National Bird)",
    hint: "Declared the National Bird of India in 1963, famous for its fan-shaped tail feathers.",
    funFact: "Its majestic dance heralds the arrival of the life-giving monsoon clouds across India."
  },
  {
    id: 'riddle_7',
    category: "Solar System & Astronomy",
    emojis: ["☀️", "🪐", "🌍", "🔭"],
    emojiClues: ["Yellow Star", "Ringed Giant", "Blue Earth", "Astronomer Telescope"],
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=600&q=80",
    options: [
      { text: "Andromeda Galaxy", emoji: "🌌" },
      { text: "Milky Way Spirals", emoji: "🌠" },
      { text: "Our Solar System (8 Planets)", emoji: "🪐" },
      { text: "Orion Constellation", emoji: "⭐" }
    ],
    correctIndex: 2,
    answer: "Our Solar System (8 Planets)",
    hint: "Our cosmic home where 8 planets and asteroid belts circle our golden sun.",
    funFact: "Jupiter is so gigantic that all other 7 planets could fit inside it combined!"
  },
  {
    id: 'riddle_8',
    category: "Inventions & Daily Science",
    emojis: ["💡", "⚡", "🔬", "🏠"],
    emojiClues: ["Glowing Bulb", "Electric Wire", "Research Lab", "Lighting Homes"],
    image: "https://images.unsplash.com/photo-1493612276216-ee3925520721?auto=format&fit=crop&w=600&q=80",
    options: [
      { text: "Electric Light Bulb", emoji: "💡" },
      { text: "Telephone (Alexander Bell)", emoji: "☎️" },
      { text: "Electric Motor (Michael Faraday)", emoji: "⚙️" },
      { text: "Steam Locomotive Train", emoji: "🚂" }
    ],
    correctIndex: 0,
    answer: "Electric Light Bulb",
    hint: "Invented by Thomas Edison to brighten up schools, hospitals, and homes at night.",
    funFact: "Early filaments were made using carbonized bamboo and cotton threads!"
  }
];

const STORAGE_KEY_EMOJI_RIDDLES = 'gamifycenter_emoji_riddles';

export const getEmojiRiddles = () => {
  if (typeof window === 'undefined') return DEFAULT_EMOJI_RIDDLES;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_EMOJI_RIDDLES);
    if (!raw) return DEFAULT_EMOJI_RIDDLES;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : DEFAULT_EMOJI_RIDDLES;
  } catch (e) {
    return DEFAULT_EMOJI_RIDDLES;
  }
};

export const saveEmojiRiddles = (riddles) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY_EMOJI_RIDDLES, JSON.stringify(riddles));
    window.dispatchEvent(new Event('emojiRiddlesUpdated'));
  } catch (e) {
    console.warn('Failed to save emoji riddles', e);
  }
};

export const getBalloonEntries = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY_BALLOON_ENTRIES);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

export const saveBalloonEntry = (entry) => {
  if (typeof window === 'undefined') return;
  try {
    const current = getBalloonEntries();
    const updated = [entry, ...current];
    localStorage.setItem(STORAGE_KEY_BALLOON_ENTRIES, JSON.stringify(updated));
    window.dispatchEvent(new Event('balloonEntriesUpdated'));
  } catch (e) {
    console.warn('Failed to save balloon entry', e);
  }
};

// --- Speed Word Scramble Dataset for Live Projector ---
export const DEFAULT_SCRAMBLE_WORDS = [
  {
    id: 'scram_1',
    word: 'CHANDRAYAAN',
    hint: 'India\'s historic lunar spacecraft that soft-landed near the Moon\'s south pole in 2023.',
    category: 'Space Exploration',
    funFact: 'Chandrayaan translates to "Moon Craft" in ancient Sanskrit.'
  },
  {
    id: 'scram_2',
    word: 'SARNATH',
    hint: 'Ancient historic monument site near Varanasi where the 4-Lion Ashoka Capital was carved.',
    category: 'Indian Heritage',
    funFact: 'The 4 Sarnath lions symbolize power, courage, pride, and confidence.'
  },
  {
    id: 'scram_3',
    word: 'PHOTOSYNTHESIS',
    hint: 'The vital green leaf process converting sunlight, carbon dioxide, and water into oxygen.',
    category: 'Science & Biology',
    funFact: 'Almost all the oxygen in Earth\'s atmosphere originated from photosynthesis!'
  },
  {
    id: 'scram_4',
    word: 'ARYABHATTA',
    hint: 'Legendary Indian mathematician-astronomer who discovered the concept of zero and Pi.',
    category: 'Great Indian Minds',
    funFact: 'India\'s first indigenously designed space satellite launched in 1975 was named in his honor.'
  },
  {
    id: 'scram_5',
    word: 'MANGALYAAN',
    hint: 'India\'s Mars Orbiter Mission that reached the Red Planet on its maiden maiden attempt.',
    category: 'Space Exploration',
    funFact: 'India was the very first nation in the world to reach Mars orbit on its first try!'
  },
  {
    id: 'scram_6',
    word: 'HIMALAYAS',
    hint: 'The majestic snow-capped mountain range home to Mount Everest and Ganga\'s origin.',
    category: 'Geography & Nature',
    funFact: 'The Himalayas are the youngest and highest mountain range on Earth, still growing taller each year.'
  },
  {
    id: 'scram_7',
    word: 'ASHOKA',
    hint: 'The great emperor whose 24-spoke Dharma wheel graces the center of our National Tricolor.',
    category: 'Indian History',
    funFact: 'Ashoka championed non-violence, public welfare, and environmental protection across ancient India.'
  },
  {
    id: 'scram_8',
    word: 'BENGAL TIGER',
    hint: 'The majestic royal predator with orange and black stripes that serves as India\'s National Animal.',
    category: 'Wildlife & Nature',
    funFact: 'Project Tiger, launched in 1973, has helped India protect over 75% of the global wild tiger population.'
  }
];

// --- Magic Treasure Chest Kiosk Dataset ---
const STORAGE_KEY_TREASURE_ENTRIES = 'school_treasure_entries';

export const getTreasureEntries = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY_TREASURE_ENTRIES);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};

export const saveTreasureEntry = (entry) => {
  if (typeof window === 'undefined') return;
  try {
    const current = getTreasureEntries();
    const updated = [entry, ...current];
    localStorage.setItem(STORAGE_KEY_TREASURE_ENTRIES, JSON.stringify(updated));
    window.dispatchEvent(new Event('treasureEntriesUpdated'));
  } catch (e) {
    console.warn('Failed to save treasure entry', e);
  }
};

